import PastDuesPerformanceModule from "./PastDuesPerformanceModule";
import reducer from "./redux/pastDuePerformanceReducer";
import rootSaga from "./redux/pastDuePerformanceSagas";

export default {
  Component: PastDuesPerformanceModule,
  moduleName: "pastDuesPerformance",
  saga: rootSaga(),
  reducer: reducer
};
